/* exported getDataAllPage clikeOnAd */
function clikeOnAd(cardProduct){
	sessionStorage.setItem('openedFrom', cardProduct.getAttribute('data-openedFrom'));
	sessionStorage.setItem('componentType', cardProduct.getAttribute('data-componentType'));
	sessionStorage.setItem('componentHeader', cardProduct.getAttribute('data-componentHeader'));
	sessionStorage.setItem('location', cardProduct.getAttribute('data-location'));
	sessionStorage.setItem('locationForCheckout', cardProduct.getAttribute('data-location'));
}
function getDataAllPage() {
	const mainContent = document.getElementById('main-content');
	const customer = mainContent.getAttribute('data-mid');
	const pageType = getPageTypeFromUrl();
	const body = {
		event: 'dl_page',
		Environment: 'production',
		SiteType: 'react',
		// Need to fix
		Rversion: getDeviceType(),
		PageType: pageType,
		Section: 'shopify',
		Category: '20',
		SubCategory: '0',
	};
	if (customer) {
		body.UserID = customer;
	}
	return body;

}

function getDeviceType() {
	const userAgent = navigator.userAgent;
	if(!userAgent.includes('RESPONSIVE_MOBILE_APP')) {
		return getDeviceTypeWeb();
	}
	return getDeviceTypeMobile(userAgent);
}

// RESPONSIVE_DESKTOP_WEB_3.0 / RESPONSIVE_MOBILE_APP_ANDROID /
// RESPONSIVE_MOBILE_APP_IOS /
// RESPONSIVE_MOBILE_WEB_3.0 / 
// RESPONSIVE_TABLET_WEB_3.0 /  
// RESPONSIVE_NATIVE_MOBILE_APP_IOS / RESPONSIVE_NATIVE_MOBILE_APP_ANDROID 


function getDeviceTypeMobile(userAgent) {
	const isInReactNativeWebView = typeof window.ReactNativeWebView !== 'undefined';
	if(!isInReactNativeWebView)
	{
		return 'RESPONSIVE_MOBILE_WEB_3.0 '
	}
	if (userAgent.includes('ANDROID')) {
		return 'RESPONSIVE_NATIVE_MOBILE_APP_ANDROID';
	} 
	return 'RESPONSIVE_NATIVE_MOBILE_APP_IOS';
} 

function getDeviceTypeWeb() {
	const screenWidth = window.innerWidth;
	if (screenWidth <= 767) {
		return 'RESPONSIVE_MOBILE_WEB_3.0';
	} else if (screenWidth <= 1024) {
		return 'RESPONSIVE_TABLET_WEB_3.0';
	} else {
		return 'RESPONSIVE_DESKTOP_WEB_3.0';
	}
}

function getPageTypeFromUrl() {
	const currentURL = window.location.href;
	const partsCurrentURL = currentURL.split('/');
	if (partsCurrentURL[partsCurrentURL.length - 1] === '') {
		return 'recommerce_lobby';
	}
	if (partsCurrentURL[partsCurrentURL.length - 2] === 'products') {
		return 'item';
	}
	if (partsCurrentURL[partsCurrentURL.length - 2] === 'collections' || partsCurrentURL[partsCurrentURL.length - 1].includes('search')) {
		return 'feed';
	}
	return 'null';
}